import { getToday } from "../utils";
import { contatos, contatosNoDia, metaDe } from "./metas";
import { somarDias } from "./abordagem";

// ═══════════════════════════════════════════════════════════════
// INCENTIVO — reconhecer o que foi feito, não empurrar frase pronta
// ═══════════════════════════════════════════════════════════════
//
// "Vamos lá, você consegue!" repetido todo dia vira ruído em uma semana, e
// pior: soa falso para quem está tendo um dia ruim de verdade. Toda mensagem
// aqui nasce de um FATO da trilha — a sequência de dias batendo a meta, o
// primeiro aceite do dia, a proporção de contatos com prova.
//
// Reconhecimento específico é o que funciona. Genérico é enfeite.

/** Quantos dias úteis seguidos (até ontem) a pessoa bateu a meta. */
export function sequencia(partners, userId, metas, hoje = getToday()) {
  const meta = metaDe(metas, userId);
  if (!meta.contatosDia) return 0;
  const lista = contatos(partners, { userId });
  let dias = 0;
  for (let i = 0; i < 30; i++) {
    const dia = somarDias(hoje, -i);
    const semana = new Date(`${dia}T12:00:00Z`).getUTCDay();
    if (semana === 0 || semana === 6) continue;
    const feitos = contatosNoDia(lista, dia).length;
    if (feitos >= meta.contatosDia) dias += 1;
    else if (dia !== hoje) break;   // o dia de hoje ainda não fechou
    else continue;
  }
  return dias;
}

/**
 * A mensagem do momento. Devolve null quando não há nada honesto a dizer —
 * silêncio é melhor do que elogio vazio.
 */
export function mensagem({ partners = [], metas = [], userId, hoje = getToday(), progresso }) {
  const p = progresso;
  if (!p) return null;
  const seq = sequencia(partners, userId, metas, hoje);

  if (p.bateu && seq >= 5) {
    return { tom: "ouro", texto: `${seq} dias seguidos batendo a meta. Isso é consistência, não sorte.` };
  }
  if (p.bateu && seq >= 2) {
    return { tom: "bom", texto: `Meta batida — ${seq} dias seguidos. Sequência assim é o que enche a rede.` };
  }
  if (p.bateu) {
    return { tom: "bom", texto: "Meta do dia batida. Cada contato registrado hoje é um parceiro a mais possível amanhã." };
  }
  if (p.meta > 0 && p.faltam === 1) {
    return { tom: "quase", texto: "Falta 1 contato para fechar o dia. Provavelmente está a uma mensagem de distância." };
  }
  if (p.feitos > 0 && p.percentual >= 60) {
    return { tom: "quase", texto: `${p.percentual}% da meta antes de terminar o dia. Faltam ${p.faltam}.` };
  }
  if (p.feitos > 0 && p.comProva === p.feitos && p.feitos >= 3) {
    return { tom: "bom", texto: "Todos os contatos de hoje com print anexado. É assim que a gerência consegue defender seu trabalho." };
  }
  if (p.feitos === 0 && seq >= 3) {
    return { tom: "lembrete", texto: `Você vem de ${seq} dias batendo a meta. O primeiro contato de hoje mantém a sequência viva.` };
  }
  if (p.feitos === 0) {
    return { tom: "lembrete", texto: "O dia ainda não tem contato registrado. O primeiro costuma ser o mais difícil." };
  }
  return null;
}

export const CORES_TOM = {
  ouro: { fundo: "#fffbeb", borda: "#fcd34d", texto: "#92400e" },
  bom: { fundo: "#f0fdf4", borda: "#bbf7d0", texto: "#166534" },
  quase: { fundo: "#eff6ff", borda: "#bfdbfe", texto: "#1d4ed8" },
  lembrete: { fundo: "#f8fafc", borda: "#e2e8f0", texto: "#475569" },
};
